// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./utils/Header/Header";
import About from "../src/pages/About/About";
import Home from "./pages/Home/Home";
import Products from "./pages/Products/ProductPage"
import ProductDetailsPage from "./pages/Products/ProductDetailPage";
import Dealermap from "./pages/Dealermap/Dealermap";
import Calculator from "./pages/Tools/Calculator";
import Footer from './utils/Footer/Footer'
import ScrollToTop from './utils/ScrollToTop';
import ColorCatalogueimg from "./pages/Catalogue/ColorCatalogueimg";
import Contactus from "./pages/Contact/Contactus";

function App() {
  return (
    <Router>
      <ScrollToTop />
      
      <Header /> 

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/product/:id" element={<ProductDetailsPage />} />
        <Route path="/dealer-info" element={<Dealermap />} />
        <Route path='/catalogue' element={<ColorCatalogueimg/>}/>
        <Route path="/calculator" element={<Calculator/>}/>
        <Route path="/contactus" element={<Contactus/>}/>

      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;